import { commonFilter } from './filter';

export default {
  pageName: 'GameStore',
  pageId: '20024',
  pagePath: '/opinion/GameStore',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    G_ScoreFilter: {
      buttonId: '2002401',
    },
    G_Alter: {
      buttonId: '2002402',
    },
    G_Collected: {
      buttonId: '2002403',
    },
    G_Setting: {
      buttonId: '2002404',
    },
    ...commonFilter,
  },
};
